export default {
  'pages.category.title1': 'Category  I',
  'pages.category.title2': 'Category  II',
  'pages.category.title3': 'Category III',
  'pages.category.allGoods': 'All items',
  'pages.category.empty': 'No such product available, please stay tuned!',
  'pages.category.total': ' ',
  'pages.category.del': 'Clear option',
  'pages.category.unity': 'items in total',
  'pages.category.allCategory': 'All Category ',
  'pages.category.news': 'Market Trend',
  'pages.category.ours': 'About BEUKAY',
  'pages.category.name': 'Category',
  'pages.category.more': 'More',
  'pages.category.close': 'Close',
  'pages.category.merch': 'Merch classification',
  'pages.category.attr': 'Attribute classification',
};
